import {
  // DeleteOutlined,
  // EditOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import { TableColumnsType } from "antd";

import { IShortTermPlan } from "@types";
import { checkPermission } from "@/utils";
import { permissions } from "@/router";
import { GoPencil } from "react-icons/go";
import { BsTrash3 } from "react-icons/bs";

export const getColumns = ({
  removeShortTermPlan,
  shortTermPlan_id,
  isDeleting,
  editShortTermPlan,
}: {
  removeShortTermPlan: (id: number) => Promise<void>;
  shortTermPlan_id: React.MutableRefObject<any>;
  isDeleting: boolean;
  editShortTermPlan: (selectedShortTermPlan: IShortTermPlan) => void;
}): TableColumnsType<any> => [
    {
      title: "plan name",
      dataIndex: "name",
      key: "name",
      width: 250,
      sorter: true,
      align: "center",
    },
    {
      title: "plan type",
      dataIndex: "type",
      key: "type",
      width: 250,
      render: (type: { id: number; name: string }) => type.name,
      sorter: true,
      align: "center",
    },
    {
      title: "grades",
      key: "grades",
      width: !checkPermission([
        permissions.DELETE_COMPANY_STI,
        permissions.UPDATE_COMPANY_STI,
      ])
        ? 200
        : 300,
      render: (plan: IShortTermPlan) => (
        <div className="text-wrap">
          {plan?.is_all_grade
            ? "All Grades"
            : plan?.grades
              ?.map((grade: any) => grade || "")
              .join(", ")}
        </div>
      ),
      sorter: true,
      align: "center",
    },
    {
      title: "Countries",
      key: "coverage",
      width: !checkPermission([
        permissions.DELETE_COMPANY_STI,
        permissions.UPDATE_COMPANY_STI,
      ])
        ? 200
        : 200,
      render: (plan: IShortTermPlan) => (
        <div className="text-wrap">
          {plan?.is_global
            ? "Global"
            : plan?.countries?.map(country => country?.name).join(", ")}
        </div>
      ),
      sorter: true,
      align: "center",
    },
    {
      title: "function",
      dataIndex: "job_function",
      key: "job_function",
      width: 200,
      render: (job_function: any[]) => (
        <div>
          {job_function?.length
            ? job_function.map((item) => item?.name).join(", ")
            : "-"}
        </div>
      ),
      sorter: true,
      align: "center",
    },
    {
      title: "sub function",
      dataIndex: "job_sub_function",
      key: "job_sub_function",
      width: 250,
      render: (job_sub_function: any[]) => (
        <div>
          {job_sub_function?.length
            ? job_sub_function.map((item) => item?.name).join(", ")
            : "-"}
        </div>
      ),
      sorter: true,
      align: "center",
    },
    ...(!checkPermission([
      permissions.DELETE_COMPANY_STI,
      permissions.UPDATE_COMPANY_STI,
    ])
      ? []
      : ([
        {
          title: "Actions",
          key: "actions",
          width: 160,
          fixed: "right",
          align: "center",
          render: (shortTermPlan: IShortTermPlan) => (
            <div className="flex items-center gap-2">
              {checkPermission(permissions.UPDATE_COMPANY_STI) && (
                <div
                  onClick={event => {
                    event.stopPropagation();
                    editShortTermPlan(shortTermPlan);
                  }}
                  className="table__action__btn table__action__btn--client"
                >
                  <GoPencil className="text-white mr-1 text-sm" /> Edit
                </div>
              )}
              {checkPermission(permissions.DELETE_COMPANY_STI) && (
                <div
                  onClick={event => {
                    event.stopPropagation();
                    removeShortTermPlan(shortTermPlan?.id);
                  }}
                  className="table__action__btn table__action__btn--delete"
                >
                  {isDeleting &&
                    shortTermPlan?.id === shortTermPlan_id?.current ? (
                    <LoadingOutlined color="#B62424" className="spinner" />
                  ) : (
                    <>
                      <BsTrash3 className="text-white textx mr-1" /> Delete
                    </>
                  )}
                </div>
              )}
            </div>
          ),
        },
      ] as any)),
  ];
